<template>
    <section class="Section WhiteSnow">
        <div class="Container">
            <div class="BoxWide">
                <h5>Parti</h5>
                <div class="TabellaGenerale"> 
                    <table width="100%" border="0" cellspacing="0" cellpadding="0">
                        <tbody>
                            <tr>
                                <th scope="col">Codice</th>
                                <th scope="col">Descrizione</th>
                                <th scope="col">Marca</th>
                                <th scope="col">Modello</th>
                                <th scope="col">Matricola</th>
                            </tr>
                            <!-- Inizio repeater -->
                            <RigaGrigliaParti v-for="(parte,index) in this.listaPartiShow" :key="index" :rigaParti="parte" :index="index"></RigaGrigliaParti>
                            <!-- Fine repeater -->
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import RigaGrigliaParti from "@/components/RigaGrigliaParti.vue";


export default {
    name: "GrigliaParti",
    data(){
        return {
            listaPartiShow: null
        }
    },

    components: {
        RigaGrigliaParti
    },
    
    props: {
        listaParti: Array
    },

    watch: {
        listaParti: function(newValue){
            this.listaPartiShow = newValue;
        }
    }
}
</script>
